module.exports = __webpack_public_path__ + "static/media/599.7554(11).038d90cf.pdf";